import { SERVER_ALL_VALUE } from '../Constants'
import { IsVarEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Returns the prefilled scope device number that should trigger linked-entity add-user hydration once device options load.
 *
 * @param initialDeviceNumber - Prefilled scope device from modal launch state.
 * @param currentDeviceNumber - Current scope device value in the form.
 * @param hasHydrated - Whether the one-time hydration has already run.
 * @param availableDeviceValues - Available scope device option values.
 * @returns The device number to hydrate, or {@code null} when no hydration should run.
 */
export const getInitialScopeDeviceToHydrate = (
    initialDeviceNumber: Nullable<string>,
    currentDeviceNumber: Nullable<string>,
    hasHydrated: boolean,
    availableDeviceValues: readonly string[]
): Nullable<string> => {
    if (hasHydrated || IsVarEmpty(initialDeviceNumber) || IsVarEmpty(currentDeviceNumber)) return null

    if (initialDeviceNumber === SERVER_ALL_VALUE || currentDeviceNumber !== initialDeviceNumber) return null

    return availableDeviceValues.includes(initialDeviceNumber) ? initialDeviceNumber : null
}
